'use client'

import Skeleton from 'react-loading-skeleton'

export default function SwitcherItemSkeleton() {
  return (
    <li className="switcher__item">
      <div className="switcher__item-info">
        <span className="switcher__item-name">
          <Skeleton width={120} />
        </span>
        <span className="switcher__item-description">
          <Skeleton width={70} />
          {'\n'}
          <Skeleton width={80} />
        </span>
      </div>
    </li>
  )
}
